const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function createRoom(recruiterSessionId) {
  const res = await fetch(`${API}/staffing/rooms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ recruiter_session_id: recruiterSessionId }),
  });
  if (!res.ok) throw new Error(`createRoom ${res.status}`);
  return res.json();
}

export async function getRoom(roomId) {
  const res = await fetch(`${API}/staffing/rooms/${encodeURIComponent(roomId)}`);
  if (!res.ok) throw new Error(`getRoom ${res.status}`);
  return res.json();
}

export async function closeRoom(roomId) {
  const res = await fetch(`${API}/staffing/rooms/${encodeURIComponent(roomId)}`, {
    method: 'DELETE',
  });
  if (!res.ok) throw new Error(`closeRoom ${res.status}`);
  return res.json();
}

export async function getStaffingQuestions() {
  const res = await fetch(`${API}/staffing/questions`);
  if (!res.ok) throw new Error(`getStaffingQuestions ${res.status}`);
  return res.json();
}

/**
 * Phase 11 — fetch aggregated analytics for a recruiter.
 * @param {string} recruiterSessionId
 * @param {'free' | 'business'} plan
 */
export async function getStaffingAnalytics(recruiterSessionId, plan = 'free') {
  const url = new URL(`${API}/staffing/analytics`);
  if (recruiterSessionId) url.searchParams.set('recruiter_session_id', recruiterSessionId);
  url.searchParams.set('plan', plan);
  const res = await fetch(url.toString());
  if (!res.ok) throw new Error(`getStaffingAnalytics ${res.status}`);
  return res.json();
}
